module.exports = __webpack_public_path__ + "img/jiabin4.565b8be2.png";